import { __extends } from "tslib";
import React from 'react';
var Spinner = (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        return (React.createElement("div", { className: 'rb-spinner' },
            React.createElement("img", { src: require('images/common/spinner.gif'), alt: 'spinner' })));
    };
    return Spinner;
}(React.PureComponent));
export { Spinner };
